// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610071006/js/" + chunkId + "." + {"44":"6d3b8e73","225":"1204d989","481":"16cd0571","486":"90d805b6","770":"d5d5f7c9"}[chunkId] + ".0.25238233770750296.chunk.js";
};